import React from 'react';

/**
 * Stepper 进度条组件
 * @param {Array} steps - 步骤数组 [{ label, value }]
 * @param {string} current - 当前状态 value
 */
const Stepper = ({ steps, current }) => {
  // 找到当前步骤索引
  const currentIndex = steps.findIndex(step => step.value === current);

  return (
    <div className="flex items-center w-full py-4">
      {steps.map((step, idx) => {
        const isActive = idx === currentIndex;
        const isCompleted = idx < currentIndex;
        return (
          <React.Fragment key={step.value}>
            <div className="flex flex-col items-center">
              <div
                className={`w-8 h-8 flex items-center justify-center rounded-full border-2 text-sm font-bold transition-all duration-200
                  ${isActive ? 'bg-emerald-500 border-emerald-500 text-white' : isCompleted ? 'bg-emerald-100 border-emerald-300 text-emerald-700' : 'bg-white border-gray-300 text-gray-400'}`}
              >
                {idx + 1}
              </div>
              <span className={`mt-2 text-xs ${isActive ? 'text-emerald-600 font-semibold' : 'text-gray-500'}`}>{step.label}</span>
            </div>
            {idx < steps.length - 1 && (
              <div className={`flex-1 h-1 mx-2 rounded-full transition-all duration-200 ${idx < currentIndex ? 'bg-emerald-400' : 'bg-gray-200'}`}></div>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default Stepper; 